import { minor, type AccountingSnapshot, type Owner } from "../../money/types";
import { floorRateFromMinor } from "../../money/rates";
import type { MoneyValues } from "./model";

export function enteredExchangeRate(action: "cycle-start" | "alipay", values: MoneyValues): bigint | null {
  try {
    const source = action === "cycle-start"
      ? values.owner === "both" ? BigInt(minor(values.kolya)) + BigInt(minor(values.vlad)) : BigInt(minor(values.sourceAmount))
      : BigInt(minor(values.sourceAmount, "USDT"));
    const target = BigInt(minor(values.targetAmount, action === "cycle-start" ? "USDT" : "CNY"));
    if (source <= 0n || target <= 0n) return null;
    return action === "cycle-start" ? floorRateFromMinor(source, 0, target, 1) : floorRateFromMinor(target, 2, source, 1);
  } catch { return null; }
}

export function savedUsdtRate(snapshot: AccountingSnapshot, owner: Owner): number | null {
  const cycles = snapshot.cycles.filter(c => c.owner_party === owner && c.status === "open");
  const value = cycles.length === 1 ? cycles[0].start_rate_hundredths : undefined;
  return typeof value === "number" && Number.isSafeInteger(value) && value >= 0 ? value : null;
}
